import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';

import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/hardware-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/paper-toast/paper-toast.js';
import '../input-element/input-element.js';
import '../katapult-elements/katapult-button.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../katapult-toolbar/katapult-toolbar';

class KatapultHelpPage extends KatapultPageElement {
  static get template() {
    return html`
      <style include="paper-dialog-style paper-tooltip-style paper-menu-button-style">
        /* HEADER STYLES */
        .header {
          font-weight: 600;
          font-size: 3rem;
          text-transform: uppercase;
          margin-bottom: 1rem;
        }
        #header {
          justify-content: center;
          white-space: nowrap;
          flex-wrap: nowrap;
          display: flex;
          padding: 24px;
          box-shadow:
            0 2px 2px 0 rgba(0, 0, 0, 0.14),
            0 1px 5px 0 rgba(0, 0, 0, 0.12),
            0 3px 1px -2px rgba(0, 0, 0, 0.2);
          background-color: #003e51;
          color: white;
          font-size: 18pt;
        }

        /* BODY STYLES */
        #body {
          width: 100%;
          height: 100%;
          overflow: auto;
          position: relative;
        }

        /* FOOTER STYLES */
        .footer {
          display: flex;
          flex-direction: column;
          background: #003e51;
          align-items: center;
          color: white;
          width: 100%;
          bottom: 0;
        }
        .footer > div {
          margin-top: auto;
          padding: 1em 1em 0 1em;
          text-align: center;
        }
        #footer-top {
          font-size: 16pt;
        }
        #footer-bottom {
          padding-bottom: 1em;
          margin-bottom: 50px;
        }
        .footer a {
          color: inherit;
        }

        /* MAIN CONTENT STYLES */
        #mainContent {
          display: flex;
          flex-direction: column;
          flex: 1;
          align-items: center;
          padding: 1em 2.5em;
          margin-bottom: 50px;
        }
        #main-video {
          padding: 2em;
        }

        /* DOCUMENTATION DIVS STYLE*/
        #documentationBlock {
          margin: 1em;
          width: 100%;
          display: grid;
          grid-template-columns: 33.33% 33.33% 33.33%;
          column-gap: 50px;
        }
        .building-blocks {
          display: grid;
          grid-column: 1;
        }
        .building-block {
          border: 1px solid gray;
          border-radius: 10px;
          padding: 20px;
          display: flex;
          flex-flow: column wrap;
          margin-top: 25px;
        }
        .building-block-title {
          font-size: 18pt;
          font-weight: bold;
          color: #003e51;
          text-align: center;
          margin-bottom: 15px;
        }
        .building-block-subtitle {
          font-weight: bold;
          color: #003e51;
          text-align: center;
        }
        .workflow {
          grid-column-start: 2;
          grid-column-end: 4;
          border: 1px solid gray;
          border-radius: 10px;
          padding: 20px;
          margin: 25px 100px 0 0;
          display: grid;
          column-gap: 1.5em;
          grid-template-columns: auto auto;
        }
        .workflow > .building-block-title,
        .workflow > .building-block-subtitle {
          grid-column: 1 / 3;
        }
        .step {
          display: flex;
          flex-flow: column wrap;
          border: 1px solid gray;
          border-radius: 10px;
          padding: 20px;
          margin-top: 25px;
        }
        .step-header {
          display: flex;
          flex-flow: row nowrap;
          padding: 1em;
          gap: 16px;
          align-items: center;
          color: #717271;
        }
        .step-title,
        .step-blurb {
          flex-shrink: 3;
        }
        .step-title {
          font-weight: bold;
        }

        /* LINKS STYLES */
        .links {
          text-align: left;
        }
        ul {
          list-style-type: none;
          margin-top: 20px;
        }
        .links li {
          line-height: 24px;
          margin: 5px 0px;
          text-decoration: underline;
          color: #ff8300;
        }
        .links a {
          color: #ff8300;
        }
        .links a:visited {
          color: #003e51;
        }

        /* DECORATIVE TIDBITS STYLES */
        .circle-number {
          font-weight: bold;
          min-height: 25px;
          min-width: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1em;
          border-radius: 100%;
          box-sizing: border-box;
          border: 2px solid #717271;
          border-color: #717271;
        }
        .insert-line {
          width: 100%;
          border-bottom: 1px solid lightgray;
          margin: 10px 0px;
        }

        /* DIFFERENT SCREEN STYLES - LAYOUT */
        @media only screen and (max-width: 1200px) {
          #documentationBlock {
            display: flex;
            flex-flow: wrap row;
          }
          .workflow {
            width: 100%;
            display: flex;
            flex-flow: column wrap;
            margin: 25px 0 0 0;
          }
        }
        @media only screen and (max-device-width: 480px) {
          #documentationBlock {
            display: flex;
            flex-flow: wrap row;
          }
          .workflow {
            width: 100%;
            display: flex;
            flex-flow: column wrap;
            margin: 25px 0 0 0;
          }
        }
      </style>

      <!-- backend data -->
      <firebase-document path="photoheight/help/help2" data="{{helpData}}" on-data-changed="helpDataLoaded"></firebase-document>

      <!-- toolbar -->
      <katapult-toolbar>
        <!-- left -->
        <div id="title" slot="left" style="display: flex; justify-content: center; align-items: center;">
          <div
            style="display: inline-block; text-transform: uppercase; font-size: 18pt; text-color: var(--primary-text-color-faded); font-weight: lighter"
          >
            Katapult Pro Help
          </div>
        </div>
        <template is="dom-if" if="[[modelOptions.length]]">
          <div slot="center" id="modelEditorDropdown">
            <katapult-drop-down
              items="[[modelOptions]]"
              value="{{editingCompany}}"
              label="Models"
              label-path="label"
              value-path="value"
            ></katapult-drop-down>
            <template is="dom-if" if="{{systemAdmin}}">
              <iron-icon icon="icons:add" on-click="openModelSetDialog"></iron-icon>
            </template>
          </div>
        </template>
        <!-- right -->
        <div slot="right"></div>
      </katapult-toolbar>

      <div id="body">
        <!-- header -->
        <div id="header">
          <span>Need help? Find our documentation for our software below!</span>
        </div>

        <!-- main content -->
        <div id="mainContent">
          <!-- demo video -->
          <div id="main-video">
            <iframe
              width="1010"
              height="568"
              src="https://www.youtube.com/embed/XZNVV0fphhQ"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>

          <!-- documentation -->
          <div id="documentationBlock">
            <div class="building-blocks">
              <template is="dom-repeat" items="{{helpData.blocks}}" as="block">
                <div class="building-block">
                  <div class="building-block-title">
                    {{block.title}}
                    <!-- title -->
                  </div>
                  <div class="building-block-subtitle">
                    {{block.blurb}}
                    <!-- blurb -->
                  </div>
                  <ul class="links">
                    <template is="dom-repeat" items="{{block.links}}" as="link">
                      <li><a target="_blank" href="{{link.link}}">{{link.label}}</a></li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>

            <div class="workflow">
              <div class="building-block-title">Workflow</div>
              <div class="building-block-subtitle">
                Find documentation as it relates to the following steps in the pole attachments workflow:
              </div>
              <template is="dom-repeat" items="{{helpData.workflow}}" as="step" index-as="stepNumber">
                <div style="{{getStyle(stepNumber)}}" class="step">
                  <div class="step-header">
                    <div class="circle-number">{{addOne(stepNumber)}}</div>
                    <div class="step-title">{{step.title}}</div>
                    <div class="step-blurb">{{step.blurb}}</div>
                  </div>
                  <div class="insert-line"></div>
                  <ul class="links">
                    <template is="dom-repeat" items="{{step.links}}" as="link">
                      <li><a target="_blank" href="{{link.link}}">{{link.label}}</a></li>
                    </template>
                  </ul>
                </div>
              </template>
            </div>
            <!-- /workflow -->
          </div>
          <!-- /documentation -->
        </div>
        <!-- /main content -->

        <!-- footer -->
        <div class="footer">
          <div id="footer-top">
            <div>Didn't find what you need?</div>
            <div>Call us at 717.430.0910</div>
            <div>or email at <a href="mailto:support@katapultengineering.com">support@katapultengineering.com</a></div>
          </div>
          <div id="footer-bottom">
            <div>©[[getCopyrightYear()]] Katapult Engineering, Inc.</div>
            <div>[[config.firebaseData.katapult_info.address]]</div>
          </div>
        </div>
      </div>
    `;
  }

  static get is() {
    return 'katapult-help-page';
  }
  static get properties() {
    return {
      selectedModuleIndex: {
        type: String
      },
      selectedSidebarSection: {
        type: String
      },
      selectedDisplaySection: {
        type: String,
        value: 'home'
      }
    };
  }
  static get observers() {
    return ['getStyle(stepNum)'];
  }
  connectedCallback() {
    super.connectedCallback();
    this.durationIntervalId = setInterval(() => (this.durationTrigger = !this.durationTrigger), 1000);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.durationIntervalId);
  }
  ready() {
    super.ready();
    this.appConfiguration = new AppConfiguration(this);
  }
  getStyle(stepNum) {
    stepNum++; // adding 1 because indexing starts at 0
    // get number of steps
    let num = 0;
    for (var step in this.helpData.workflow) {
      if (this.helpData.workflow.hasOwnProperty(step)) ++num;
    }

    // are there an odd amount of steps?
    if (num % 2 != 0) {
      // take the last step and change style to grid-column: 1/3
      return stepNum == num ? 'grid-column: 1/3' : '';
    }
  }
  helpDataLoaded() {
    let steps = this.shadowRoot.querySelectorAll('.step');
    let numSteps = Object.keys(steps).length;
    let lastStep = steps[Object.keys(steps)[numSteps - 1]];
    if (numSteps % 2 != 0) {
      lastStep.style = 'grid-column: 1/3';
    } else {
      let secondLastStep = steps[Object.keys(steps)[numSteps - 2]];
      secondLastStep.style = 'grid-colum: 1/2';
    }
  }
  getCopyrightYear() {
    return new Date().getFullYear();
  }
  equal(a, b) {
    return a == b;
  }
  addOne(num) {
    num += 1;
    return num;
  }
}
window.customElements.define(KatapultHelpPage.is, KatapultHelpPage);
